import BankAccountsForm from "./BankAccountsForm";

export default BankAccountsForm;
